export interface User {
  id: string;
  name: string;
  email?: string;
  phone: string;
  dateOfBirth?: string;
  address?: string;
  idNumber?: string;
  shop2shopAccount?: string;
  shop2shopUserRef?: string;
  kazangAccount?: string;
  preferredStore?: string;
  profilePicture?: string;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Wallet {
  id: string;
  walletId: string; // The user-facing wallet ID (e.g., YW-JDM-53984)
  type: WalletType;
  balance: number; // Keep for backward compatibility (this is total balance)
  totalBalance: number;
  availableBalance: number;
  reservedAmount: number;
  currency: string;
  isActive: boolean;
}

export enum WalletType {
  MAIN = 'Main',
  GRANT = 'Grant',
  REWARDS = 'Rewards',
}

export interface Transaction {
  id: string;
  walletId: string;
  type: TransactionType;
  amount: number;
  currency: string;
  description: string;
  status: TransactionStatus;
  reference?: string;
  fromUserId?: string;
  toUserId?: string;
  createdAt: Date;
  updatedAt: Date;
  timestamp?: Date; // Keep for backward compatibility
  walletType?: WalletType;
}

export enum TransactionType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
  TRANSFER_IN = 'TRANSFER_IN',
  TRANSFER_OUT = 'TRANSFER_OUT',
  TOP_UP = 'TOP_UP',
}

export enum TransactionStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

export interface Order {
  id: string;
  userId: string;
  items?: OrderItem[];
  totalAmount: number;
  status: OrderStatus;
  createdAt: Date;
  updatedAt: Date;
  deliveryAddress?: string;
  storeName?: string;
  orderNumber?: string;
  allowedWallets?: OrderWalletLimit[];
}

export interface OrderWalletLimit {
  walletRef: string;
  walletId: string;
  maxAmount: number;
}

export interface OrderItem {
  id: string;
  productName: string;
  quantity: number;
  price: number;
}

export enum OrderStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  DELIVERED = 'DELIVERED',
  CANCELLED = 'CANCELLED',
}